import { pickFirstNonEmptyString } from 'shared/utils/array';
import { resolveExportDocumentName } from 'shared/domain/issue/mapping/exportDocument/resolveExportDocumentName';
import type { ExportToDocumentationArgs } from './types';

export function getExportFileName(
  file: ExportToDocumentationArgs['fileToExport']
): string | undefined {
  const preferredName = pickFirstNonEmptyString([
    file.description,
    file.title,
    file.data?.name,
  ]);

  return resolveExportDocumentName({
    preferredName,
    rawFileName: file.data?.name,
    fileExtension: file.data?.extension,
  });
}
